import { render, staticRenderFns } from "./usercenter-lt.vue?vue&type=template&id=1e3831d8&scoped=true&"
import script from "./usercenter-lt.vue?vue&type=script&lang=js&"
export * from "./usercenter-lt.vue?vue&type=script&lang=js&"
import style0 from "./usercenter-lt.vue?vue&type=style&index=0&id=1e3831d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3831d8",
  null
  
)

export default component.exports